@let data = section();
@let tabsMode = isTabsMode();

<section class="cms-slider tg-section" [class.cms-slider--tabs]="tabsMode">
    <div class="tg-container">
        <div class="cms-slider__head">
            @if (data.titleContent) {
                <div class="cms-content" [innerHTML]="data.titleContent | trustHtml"></div>
            }

            @if (!tabsMode && data.sliderItems.length > 1) {
                <div class="cms-slider__nav">
                    <button
                        class="cms-slider__arrow"
                        type="button"
                        [attr.aria-label]="'cms.slider.prev' | translate"
                        (click)="prev()"
                    >
                        <mat-icon>arrow_back_ios_new</mat-icon>
                    </button>
                    <button
                        class="cms-slider__arrow"
                        type="button"
                        [attr.aria-label]="'cms.slider.next' | translate"
                        (click)="next()"
                    >
                        <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                </div>
            }
        </div>

        @if (tabsMode && data.sliderItems.length) {
            <div class="cms-slider__tabs" role="tablist">
                @for (item of data.sliderItems; track item.id; let index = $index) {
                    <button
                        class="cms-slider__tab"
                        type="button"
                        role="tab"
                        [class.cms-slider__tab--active]="activeIndex() === index"
                        [attr.id]="'cms-slider-tab-' + item.id"
                        [attr.aria-selected]="activeIndex() === index"
                        [attr.aria-controls]="'cms-slider-panel-' + item.id"
                        (click)="selectSlide(index)"
                    >
                        {{
                            item.sliderTabName ||
                                ('cms.slider.tab' | translate: { index: index + 1 })
                        }}
                    </button>
                }
            </div>
        }

        @if (current(); as item) {
            <!-- A plain `div` (not `article`) so the tabs view can carry `role="tabpanel"`. -->
            <div
                class="cms-slider__slide"
                [attr.id]="tabsMode ? 'cms-slider-panel-' + item.id : null"
                [attr.role]="tabsMode ? 'tabpanel' : null"
                [attr.aria-labelledby]="tabsMode ? 'cms-slider-tab-' + item.id : null"
            >
                <div
                    class="cms-slider__media"
                    [class.cms-slider__media--placeholder]="!item.sliderImage?.url"
                >
                    @if (item.sliderImage?.url) {
                        <cms-image class="cms-slider__img" [media]="item.sliderImage" />
                    }
                </div>

                @if (item.sliderItemContent) {
                    <div class="cms-content" [innerHTML]="item.sliderItemContent | trustHtml"></div>
                }
            </div>
        }
    </div>
</section>
